export module Path{
    export function join(...args){
        let result = args.join('/')
        result = result
            .replace(/\/{2,}/g, '/')
            .replace('http:/', 'http://')
            .replace('https:/', 'https://')
        return result
    }

    export function replaceLastParam(path:string|undefined, newParamValue:string|number){
        if(!path) return path
        const items = path.split('/')
        items.pop()
        items.push(newParamValue.toString())
        return items.join('/')
    }
}